import { useQuery } from '@tanstack/react-query';

import { useProject } from '../projects/context';
import { projectKeys, useProjectApi } from '../projects/useProjectApi';
import { loadPlz, loadShapes } from './shapes';

// useAreaMap: Gebiete mit Bestandteilen (API) und die Flächen (öffentliche Kartendaten). PLZ-Flächen nur für die
// Leitbereiche, in denen Gebiete PLZ haben, und für zusätzlich angefragte Leitbereiche (z. B. sichtbarer Ausschnitt).
export function useAreaMap(enabled: boolean, extraPrefixes: string[] = []) {
  const { project } = useProject();
  const papi = useProjectApi();
  const shapes = useQuery({
    queryKey: projectKeys.map(project.id, 'area-shapes', {}),
    queryFn: ({ signal }) => papi.mapAreaShapes(signal),
    enabled,
  });
  const counties = useQuery({ queryKey: ['karten', 'kreise'], queryFn: () => loadShapes('kreise'), enabled, staleTime: Infinity, gcTime: Infinity });
  const prefixes = [...new Set([...(shapes.data?.areas.flatMap((a) => a.postal_codes.map((c) => c.slice(0, 2))) ?? []), ...extraPrefixes])].sort();
  const plz = useQuery({
    queryKey: ['karten', 'plz', prefixes.join(',')],
    queryFn: () => loadPlz(prefixes),
    enabled: enabled && prefixes.length > 0,
    staleTime: Infinity,
    placeholderData: (prev) => prev,
  });
  return { shapes, counties, plz };
}
